/*
  Feature that shows a dialog allowing the user to sign up for back in stock notifications with Klaviyo

  Usage:
  <bis-notification
    data-bis-notification-image="Liquid error: invalid url input"
    data-bis-notification-name=""
    data-bis-notification-variant=""
    data-bis-notification-price=""
    data-bis-notification-id=""
  >
    <button type="button" data-bis-notification-el="trigger">
      
    </button>
  </bis-notification>
*/

if (!customElements.get('bis-notification')) {
  customElements.define('bis-notification', class bisNotification extends HTMLElement {
    constructor () {
      super()

      this.elements = {
        bisTrigger: this.querySelector('[data-bis-notification-el="trigger"]'),
        dialog: null,
        form: null,
        emailInput: null,
        success: null,
      }

      this.state = {
        publicKey: 'QYzhLb',
        userEmail: null,
        image: this.dataset.bisNotificationImage,
        name: this.dataset.bisNotificationName,
        variant: this.dataset.bisNotificationVariant,
        price: this.dataset.bisNotificationPrice,
        id: this.dataset.bisNotificationId,
      }
    }

    connectedCallback () {
      this.elements.bisTrigger.addEventListener('click', () => {
        if (this.elements.dialog === null) {
          this.state.id = this.dataset.bisNotificationId
          this.state.variant = this.dataset.bisNotificationVariant

          this.buildDialog()
        } else if (this.state.id !== this.dataset.bisNotificationId) {
          this.state.id = this.dataset.bisNotificationId
          this.state.variant = this.dataset.bisNotificationVariant

          this.querySelector('.bis-notification-ProdTitle').textContent = `${this.state.name} ( ${this.state.variant} )`
        }
        this.elements.dialog.showModal()
      })
    }

    buildDialog () {
      const dialogEl = document.createElement('dialog')
      const closeButton = document.createElement('button')
      const header = document.createElement('h2')
      const description = document.createElement('p')
      const prodDetails = document.createElement('div')
      const image = document.createElement('img')
      const prodTitle = document.createElement('h3')
      const price = document.createElement('p')
      const form = document.createElement('form')
      const email = document.createElement('input')
      const submitButton = document.createElement('button')
      const success = document.createElement('p')
      const footer = document.createElement('p')

      dialogEl.classList.add('bis-notification-Dialog')

      closeButton.classList.add('bis-notification-Close')
      closeButton.type = 'button'
      closeButton.setAttribute('aria-label', 'Close sign up dialog')
      closeButton.innerHTML = this.closeSvg()

      header.classList.add('bis-notification-Header')
      header.textContent = "Notify me when this is available"

      description.classList.add('bis-notification-Description')
      description.textContent = "Register your email address below to receive an email should this product become available again."

      prodDetails.classList.add('bis-notification-ProdDetails')

      image.classList.add('bis-notification-Image')
      image.src = this.state.image
      image.width = 100

      prodTitle.classList.add('bis-notification-ProdTitle')
      if (this.state.variant === '' || this.state.variant === 'ONE SIZE') {
        prodTitle.textContent = this.state.name
      } else {
        prodTitle.textContent = `${this.state.name} ( ${this.state.variant} )`
      }

      price.classList.add('bis-notification-Price')
      price.textContent = this.state.price

      form.classList.add('bis-notification-Form')

      email.classList.add('bis-notification-EmailInput')
      email.type = 'email'
      email.required = true
      email.setAttribute('name', 'bisNotificationEmailInput')
      email.setAttribute('autocorrect', 'off')
      email.setAttribute('autocapitalize', 'off')
      email.setAttribute('autocomplete', 'email')
      email.setAttribute('placeholder', "Enter your email address")
      email.setAttribute('aria-label', "Enter your email address")

      submitButton.classList.add('bis-notification-Submit')
      submitButton.type = 'submit'
      submitButton.textContent = "Submit"

      success.classList.add('bis-notification-Success')
      success.textContent = "You are now signed up."
      success.style.display = 'none'

      footer.classList.add('bis-notification-Footer')
      footer.textContent = "We will send you an email once the product is available. Your email address will not be shared with anyone."

      prodDetails.append(image, prodTitle, price)
      form.append(email, submitButton)
      dialogEl.append(closeButton, header, description, prodDetails, form, success, footer)

      this.elements.userEmail = email
      this.elements.form = form
      this.elements.success = success
      this.elements.dialog = dialogEl
      this.appendChild(dialogEl)

      closeButton.addEventListener('click', () => {
        this.elements.dialog.close()
      })

      form.addEventListener('submit', (event) => {
        event.preventDefault()
        this.state.userEmail = this.elements.userEmail.value

        this.submitRequest()
      })
    }

    submitRequest () {
      const bodyData = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: this.state.userEmail,
                },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${this.state.id}`,
              },
            },
          },
        },
      }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-10-15',
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(bodyData),
      }

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.state.publicKey}`, options)
        .then(res => {
          if (res.status === 204 || res.status === 202) {
            this.elements.form.style.display = 'none'
            this.elements.success.style.display = 'block'
            return
          }
          return res.text().then(text => {
            throw new Error(text)
          })
        })
        .catch(err => console.error(err))
    }

    closeSvg () {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-close" viewBox="0 0 14 14" width="20" height="20" aria-hidden="true" focusable="false" role="presentation" fill="none">
          <path d="M.693 1.4l11.749 11.749.707-.707L1.4.693z" fill="currentColor"></path>
          <path d="M12.442.693L.693 12.442l.707.707L13.149 1.4z" fill="currentColor"></path>
        </svg>`
    }
  })
}
